import React from 'react';

const ConfirmModal = ({ isOpen, title, message, onConfirm, onCancel, confirmText = "Confirmer", cancelText = "Annuler", type = "danger" }) => {
    if (!isOpen) return null;

    const config = {
        danger: {
            headerGradient: 'from-rose-500/10 via-rose-500/5 to-transparent dark:from-rose-500/20 dark:via-rose-500/10',
            iconBg: 'bg-rose-100 dark:bg-rose-900/30',
            iconColor: 'text-rose-500',
            icon: 'delete_forever',
            btnClass: 'bg-rose-500 hover:bg-rose-600 shadow-rose-500/25',
            borderColor: 'border-rose-100 dark:border-rose-900/20',
        },
        info: {
            headerGradient: 'from-primary/10 via-primary/5 to-transparent dark:from-primary/20 dark:via-primary/10',
            iconBg: 'bg-primary/10 dark:bg-primary/20',
            iconColor: 'text-primary',
            icon: 'help',
            btnClass: 'bg-primary hover:bg-primary/90 shadow-primary/25',
            borderColor: 'border-primary/10 dark:border-primary/20',
        },
        warning: {
            headerGradient: 'from-amber-500/10 via-amber-500/5 to-transparent dark:from-amber-500/20 dark:via-amber-500/10',
            iconBg: 'bg-amber-100 dark:bg-amber-900/30',
            iconColor: 'text-amber-500',
            icon: 'warning',
            btnClass: 'bg-amber-500 hover:bg-amber-600 shadow-amber-500/25',
            borderColor: 'border-amber-100 dark:border-amber-900/20',
        },
    }[type] || {};

    return (
        <div className="fixed inset-0 z-[9000] flex items-center justify-center p-4 overflow-hidden">
            {/* Backdrop */}
            <div
                className="absolute inset-0 bg-slate-900/60 backdrop-blur-md animate-in fade-in duration-300"
                onClick={onCancel}
            />

            {/* Modal */}
            <div
                className="relative w-full max-w-sm bg-white dark:bg-slate-900 rounded-[2.5rem] shadow-2xl shadow-primary/20 border border-slate-200 dark:border-slate-800 overflow-hidden animate-in zoom-in-95 duration-500"
            >
                {/* Colored Header with Premium Design */}
                <div className={`px-8 pt-10 pb-8 text-center bg-gradient-to-br ${config.headerGradient} border-b ${config.borderColor} relative overflow-hidden`}>
                    <div className="absolute top-0 right-0 size-32 bg-white/10 rounded-full -mr-16 -mt-16 blur-3xl"></div>

                    <div className={`size-20 rounded-[2rem] flex items-center justify-center mx-auto mb-6 shadow-sm border border-white/20 relative z-10 ${config.iconBg}`}>
                        <span className={`material-symbols-outlined text-4xl ${config.iconColor}`}
                            style={{ fontVariationSettings: "'FILL' 1" }}>
                            {config.icon}
                        </span>
                    </div>
                    <h3 className="text-xl font-black text-slate-900 dark:text-white mb-2 relative z-10">{title}</h3>
                    <p className="text-slate-500 dark:text-slate-400 text-sm leading-relaxed px-4 relative z-10 font-medium">{message}</p>
                </div>

                {/* Action Buttons */}
                <div className="flex gap-4 p-8 bg-slate-50/50 dark:bg-slate-800/20">
                    <button
                        onClick={onCancel}
                        className="flex-1 py-4 text-[11px] font-black uppercase tracking-widest text-slate-500 hover:text-slate-900 dark:hover:text-white bg-white dark:bg-slate-800 border border-slate-200 dark:border-slate-700 rounded-2xl shadow-sm hover:shadow transition-all active:scale-95"
                    >
                        {cancelText}
                    </button>
                    <button
                        onClick={onConfirm}
                        className={`flex-1 py-4 text-[11px] font-black uppercase tracking-widest text-white rounded-2xl shadow-xl transition-all active:scale-95 hover:scale-[1.02] transform ${config.btnClass}`}
                    >
                        {confirmText}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ConfirmModal;
